import React, { useEffect, useState} from "react";

import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";

export const ProductPrice = ({ product, prices }) => {
    const isMobile = useMobileBreakpoint("1024px");
    const currencySymbol = '$';

    return (
        <div className="product-tile__prices flex items-center justify-center md:justify-end gap-x-2.5 px-2 flex-wrap">
            <div>
                <span className="sr-only">Regular Price</span>
                <div className="product__price h6 text-rhv-green">
                    {currencySymbol}{prices?.productPrice}
                </div>
            </div>

            {!!prices?.savings &&
                <div>
                    <span className="sr-only">Special Price</span>
                    <div className="product__sale-price line-through text-rhv-grey pt-0.5 max-lg:text-sm">
                        {currencySymbol}{((prices?.singlePrice * prices?.quantityInBundle) / 100).toFixed(2)}
                    </div>
                </div>
            }
        </div>
    );
};
